var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 25,
    rx: 4.5,
    fill: "#F8F8F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.883 9.261-1.603 7.497h-1.94l1.604-7.497h1.94Zm8.16 4.84 1.02-2.814.587 2.815h-1.608Zm2.164 2.657H29L27.433 9.26H25.78a.883.883 0 0 0-.826.55l-2.91 6.947h2.037l.404-1.12h2.488l.235 1.12Zm-5.063-2.448c.009-1.978-2.735-2.088-2.716-2.972.005-.268.262-.554.822-.627.278-.036 1.044-.065 1.913.335l.34-1.59a5.226 5.226 0 0 0-1.815-.331c-1.917 0-3.266 1.018-3.276 2.477-.013 1.08.963 1.681 1.697 2.04.756.368 1.01.604 1.006.932-.006.503-.603.726-1.16.734-.976.015-1.541-.264-1.992-.474l-.352 1.644c.454.207 1.29.388 2.156.397 2.038 0 3.371-1.006 3.377-2.565Zm-8.032-5.049-3.142 7.497H8.92l-1.546-5.983c-.094-.368-.176-.503-.46-.658-.467-.254-1.237-.49-1.914-.638l.046-.218h3.3c.42 0 .798.28.895.764l.816 4.338 2.018-5.102h2.037Z",
    fill: "#1434CB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 25,
    rx: 4.5,
    stroke: "#7F939D"
  })));
};
export default SvgVisa;